/*
  IK - Configuratore box.

  DUE AVANZAMENTI SEPARATI, perche' sono due regole diverse:
  - minimo della box: pezzi OPPURE importo (data-minimum, data-minimum-amount)
  - spedizione gratuita: soglia di spedizione (data-free-from)
  Prima erano schiacciati in una frase sola e si confondevano fra loro.

  In piu': filtri per categoria, linea e disponibilita', e riepilogo che
  su telefono resta appiccicato in basso.
*/
if (!customElements.get('ik-box-builder')) {
  customElements.define(
    'ik-box-builder',
    class extends HTMLElement {
      constructor() {
        super();
        this.minimum = Number(this.dataset.minimum || 1);
        this.minimumAmount = Number(this.dataset.minimumAmount || 0);
        this.freeFrom = Number(this.dataset.freeFrom || 0);
        this.currency = this.dataset.currency || 'EUR';
        this.products = Array.from(this.querySelectorAll('[data-box-product]'));
        this.submitButton = this.querySelector('[data-box-submit]');
        this.filters = { type: '', line: '', avail: '' };
        this.bindEvents();
        this.updateSummary();
      }

      bindEvents() {
        this.products.forEach((product) => {
          const inc = product.querySelector('[data-box-increase]');
          const dec = product.querySelector('[data-box-decrease]');
          if (inc) inc.addEventListener('click', () => this.change(product, 1));
          if (dec) dec.addEventListener('click', () => this.change(product, -1));
        });
        if (this.submitButton) this.submitButton.addEventListener('click', () => this.addToCart());

        this.querySelectorAll('[data-bb-filter]').forEach((chip) => {
          chip.addEventListener('click', () => {
            const key = chip.dataset.bbFilter;
            this.filters[key] = chip.dataset.bbValue || '';
            this.querySelectorAll('[data-bb-filter="' + key + '"]').forEach((c) => {
              c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
            });
            this.applyFilters();
          });
        });
      }

      applyFilters() {
        this.products.forEach((p) => {
          let ok = true;
          if (this.filters.type && p.dataset.type !== this.filters.type) ok = false;
          if (this.filters.line && p.dataset.line !== this.filters.line) ok = false;
          if (this.filters.avail === '1' && p.dataset.avail !== '1') ok = false;
          p.classList.toggle('is-hidden', !ok);
        });
      }

      change(product, delta) {
        const output = product.querySelector('[data-box-quantity]');
        const decrease = product.querySelector('[data-box-decrease]');
        const next = Math.max(0, Number(output.value || output.textContent || 0) + delta);
        output.value = next;
        output.textContent = next;
        decrease.disabled = next === 0;
        product.classList.toggle('is-selected', next > 0);
        this.updateSummary();
      }

      selection() {
        return this.products
          .map((product) => ({
            id: Number(product.dataset.variantId),
            title: product.dataset.title,
            price: Number(product.dataset.price || 0),
            regime: product.dataset.regime,
            line: product.dataset.line,
            type: product.dataset.type,
            quantity: Number(
              (product.querySelector('[data-box-quantity]') || {}).value ||
                (product.querySelector('[data-box-quantity]') || {}).textContent ||
                0
            ),
          }))
          .filter((item) => item.quantity > 0);
      }

      money(cents) {
        return new Intl.NumberFormat('it-IT', { style: 'currency', currency: this.currency }).format(cents / 100);
      }

      set(sel, txt) {
        const el = this.querySelector(sel);
        if (el) el.textContent = txt;
      }

      updateSummary() {
        const selected = this.selection();
        const count = selected.reduce((s, i) => s + i.quantity, 0);
        const total = selected.reduce((s, i) => s + i.price * i.quantity, 0);
        const regimes = [...new Set(selected.map((i) => i.regime).filter(Boolean))];

        const byCount = count >= this.minimum;
        const byAmount = this.minimumAmount > 0 && total >= this.minimumAmount;
        const complete = byCount || byAmount;

        this.set('[data-box-count]', String(count));
        this.set('[data-box-total]', this.money(total));
        this.set(
          '[data-box-heading]',
          count === 0 ? 'Inizia a comporla' : count === 1 ? '1 prodotto selezionato' : count + ' prodotti selezionati'
        );

        const regLine = this.querySelector('[data-box-regimes-line]');
        if (regLine) {
          regLine.hidden = regimes.length < 2;
          this.set('[data-box-regimes]', regimes.join(' + '));
        }

        /* 1. minimo della box */
        const pctItems = this.minimum > 0 ? (count / this.minimum) * 100 : 100;
        const pctAmount = this.minimumAmount > 0 ? (total / this.minimumAmount) * 100 : 0;
        const pctBox = Math.min(100, Math.round(Math.max(pctItems, pctAmount)));
        const boxMeter = this.querySelector('[data-bb-meter-box]');
        const boxFill = this.querySelector('[data-bb-box-fill]');
        if (boxFill) boxFill.style.width = pctBox + '%';
        if (boxMeter) boxMeter.classList.toggle('is-done', complete);
        this.set('[data-bb-box-state]', complete ? 'completata' : count + ' / ' + this.minimum);
        const boxHint = this.querySelector('[data-bb-box-hint]');
        if (boxHint) {
          if (complete) {
            boxHint.textContent = 'La box è completa: puoi aggiungerla al carrello.';
          } else if (this.minimumAmount > 0) {
            const missItems = Math.max(0, this.minimum - count);
            const missAmount = Math.max(0, this.minimumAmount - total);
            boxHint.textContent =
              'Aggiungi ancora ' + missItems + (missItems === 1 ? ' prodotto' : ' prodotti') +
              ', oppure arriva a ' + this.money(this.minimumAmount) + ': ti mancano ' + this.money(missAmount) + '.';
          } else {
            const missItems = Math.max(0, this.minimum - count);
            boxHint.textContent = 'Aggiungi ancora ' + missItems + (missItems === 1 ? ' prodotto' : ' prodotti') + '.';
          }
        }

        /* 2. spedizione gratuita - regola diversa, barra diversa */
        const shipMeter = this.querySelector('[data-bb-meter-ship]');
        if (shipMeter && this.freeFrom > 0) {
          const shipDone = total >= this.freeFrom;
          const pctShip = Math.min(100, Math.round((total / this.freeFrom) * 100));
          const shipFill = this.querySelector('[data-bb-ship-fill]');
          if (shipFill) shipFill.style.width = pctShip + '%';
          shipMeter.classList.toggle('is-done', shipDone);
          this.set('[data-bb-ship-state]', shipDone ? 'inclusa' : 'da ' + this.money(this.freeFrom));
          const shipHint = this.querySelector('[data-bb-ship-hint]');
          if (shipHint) {
            shipHint.textContent = shipDone
              ? 'Con questa selezione la spedizione è gratuita.'
              : 'Ti mancano ' + this.money(this.freeFrom - total) + ' alla spedizione gratuita. È una cosa diversa dal minimo della box.';
          }
        }

        if (this.submitButton) this.submitButton.disabled = !complete;

        document.dispatchEvent(
          new CustomEvent('ik:box', { detail: { count: count, total: total, complete: complete } })
        );
      }

      async addToCart() {
        const items = this.selection().map((i) => ({ id: i.id, quantity: i.quantity }));
        if (!items.length || this.submitButton.disabled) return;

        const error = this.querySelector('[data-box-error]');
        error.hidden = true;
        this.submitButton.disabled = true;
        this.submitButton.setAttribute('aria-busy', 'true');
        const originalLabel = this.submitButton.textContent;
        this.submitButton.textContent = 'Aggiunta in corso…';

        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items }),
          });
          if (!response.ok) throw new Error('Non è stato possibile aggiungere la selezione.');
          window.location.href = this.dataset.cartUrl;
        } catch (exception) {
          error.textContent = exception.message || 'Si è verificato un errore. Riprova.';
          error.hidden = false;
          this.submitButton.disabled = false;
          this.submitButton.removeAttribute('aria-busy');
          this.submitButton.textContent = originalLabel;
        }
      }
    }
  );
}
